import { useMutation, useQuery } from "@tanstack/react-query";
import {  fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
  statusCode?: number;
  statusMessage?: string;
  error?: any;
}

// --------------- Address Page Apis Start Here's --------------- //

export const useFetchAddressData = () => {
  return useQuery({
    queryKey: ["addressData"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/client/address?type=LM`, "get");

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

interface UpdateAddressPayload {
  clientAddress: string;
  country: string;
  state: string;
  city: string;
  zipCode: string;
}
export const useUpdateAddress = () => {
  return useMutation({
    mutationFn: async ({
      clientAddress,
      country,
      state,
      city,
      zipCode,
    }: UpdateAddressPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/client/update/address`,
        "PUT",
        { clientAddress, country, state, city, zipCode }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Services Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Services create request failed:", error.message);
    },
  });
};

// --------------- Address Page Apis Ends Here's --------------- //

// --------------- Bank Details Page Apis Start Here's --------------- //

export const useFetchBankDetailsData = () => {
  return useQuery({
    queryKey: ["bankDetailsData"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/client/bankDetails?type=LM`, "get");

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};
interface UpdateBankDetailsPayload {
  name: string;
  bankName: string;
  accountNo: string;
  swiftCode: string;
  iBAN: string;
}
export const useUpdateBankDetails = () => {
  return useMutation({
    mutationFn: async ({
      name,
      bankName,
      accountNo,
      swiftCode,
      iBAN,
    }: UpdateBankDetailsPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/client/update/bankDetails`,
        "PUT",
        { name, bankName, accountNo, swiftCode, iBAN }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Services Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Services create request failed:", error.message);
    },
  });
};

// --------------- Bank Details Page Apis Ends Here's --------------- //

// --------------- Change Password Page Apis Start Here's --------------- //

interface UpdatePasswordPayload {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const useUpdatePassword = () => {
  return useMutation({
    mutationFn: async ({
      currentPassword,
      newPassword,
      confirmPassword,
    }: UpdatePasswordPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/outlets/update/password?type=outlet`,
        "PATCH",
        { currentPassword, newPassword, confirmPassword }
      );

      if (!res.success) {
        throw new Error(res.message || "Password update request failed");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Password updated successfully : ", data);
    },
    onError: (error: any) => {
      console.error("Password update request failed : ", error.message);
    },
  });
};

// --------------- Change Password Page Apis Ends Here's --------------- //

// --------------- Configuration Page Apis Start Here's --------------- //

export const useFetchConfigurationData = () => {
  return useQuery({
    queryKey: ["configurationData"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/configuration?type=LM`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};
interface UpdateConfigurationPayload {
  country: string;
  currency: string;
  timeZone: string;
  dateFormat: string;
}

export const useUpdateConfiguration = () => {
  return useMutation({
    mutationFn: async ({
      country,
      currency,
      timeZone,
      dateFormat,
    }: UpdateConfigurationPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/client/update/configuration`,
        "PUT",
        { country, currency, timeZone, dateFormat }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Services Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Services create request failed:", error.message);
    },
  });
};

// --------------- Configuration Page Apis Ends Here's --------------- //

// --------------- Subscription Page Apis Start Here's --------------- //

export const useFetchSubscriptionData = () => {
  return useQuery({
    queryKey: ["subscriptionData"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/update/subscription?type=LM`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

// --------------- Subscription Page Apis Ends Here's --------------- //

export const useWebhookRegisterMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(`${url}/api/lm-client/register-webhook?type=lmClient`, payload);
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Webhook Registered Successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Webhook Registered Failed:", error.message);
    },
  });
};

export const useFetchWebhookDetails = () => {
  return useQuery({
    queryKey: ["webhookDetails"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/lm-client/webhook-details?type=lmClient`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};
